import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    pisLoading : false,
    products: [],
    productsImage: {},
    totalProduct: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    piscLoading:false,
    pcstatus:"",
    pcMessage:"",
    imagemessage:"",
    pdetails:{},
    pismloading:false,
    pmstatus:"",
    pmmessage:"",
    pSDetails: {},
    pdstatus:"",
    pidstatus:"",
    pdmessage:"",
    pidmessage:"",
    error:"",
    productId:"",
    productimageall: [],
    
};


const productSlice = createSlice({
    name: "productList",
    initialState,
    reducers:{
        getProductPending: (state) => {
            state.pisLoading = true;
        },
        getProductSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.products = payload;
           // console.log(payload);
           // state.user="slice userData";
            state.error = '';
        },
        getProductFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },

        getProductImagePending: (state) => {
            state.pisLoading = true;
        },
        getProductImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.ppliers = payload;
            state.productimageall = payload;
           // console.log(payload);
           // state.user="slice userData";
            state.error = '';
        },
        getProductImageFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },
        createProductPending:(state,action) => {
            state.piscLoading=true;
        }, 
        createProductSuccess:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="success";
            state.pcMessage="Basic Details Added Successfully";
            state.productId= payload;
            
        },
        createProductFail:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="fail";
            //console.log('slice '+payload);
            state.pcMessage=payload;
        },
        getSProductPending: (state) => {
            state.pisLoading = true;
        },
        getSProductSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.pSDetails=payload;
            // state.products=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSProductFail: (state, { payload }) => {
            state.pisLoading = false;
            state.error = payload;
        },


        getSProductImagePending: (state) => {
            state.pisLoading = true;
        },
        getSProductImageSuccess: (state, { payload }) => {
            state.pisLoading = false;
            state.productsImage=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSProductImageFail: (state, action ) => {
      
            state.pisLoading = false;
            state.error = action;
            state.imagemessage = action;
            // console.log("action11",action)
        },
        modifyProductPending:(state,action) => {
            state.pismloading=true;
            state.pmstatus="";
        },
        modifyProductSuccess:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="success";
           
            state.pmmessage="Product Successfully Updated";
        },
        modifyProductFail:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="fail";
           // console.log('slice '+payload);
            state.pmmessage=payload;
        },


        modifyProductImagePending:(state,action) => {
            state.pismloading=true;
            state.pmstatus="";
        },
        modifyProductImageSuccess:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="success";
           
            state.pmmessage="Product Successfully Updated";
        },
        modifyProductImageFail:(state,{payload}) => {
            state.pismloading=false;
            state.pmstatus="fail";
           // console.log('slice '+payload);
            state.pmmessage=payload;
        },
        deleteProductPending:(state,action) => {
            state.pisLoading=true;
            state.pdstatus="";
        },
        deleteProductSuccess:(state,{payload}) => {
            state.pisLoading=false;
            state.pdstatus="success";
            state.pdmessage="Product Successfully Deleted";
        },
        deleteProductFail:(state,{payload}) => {
            state.pisLoading=false;
            state.pdstatus="fail";
           // console.log('slice '+payload);
            state.pdmessage=payload;
        },

        deleteProductImagePending:(state,action) => {
            state.pisLoading=true;
            state.pidstatus="";
        },
        deleteProductImageSuccess:(state,{payload}) => {
            state.pisLoading=false;
            state.pidstatus="success";
            state.pidmessage="Product Successfully Deleted";
        },
        deleteProductImageFail:(state,{payload}) => {
            state.pisLoading=false;
            state.pidstatus="fail";
           // console.log('slice '+payload);
            state.pidmessage=payload;
        },

        reset: (state) => {

            state.piscLoading=false;
            state.pcstatus="false";
            state.pcMessage="";
            state.productId= "";
        },
        imageUploadSuccess:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="success";
            state.pcMessage=payload.message;
            
        },
        imageUploadFailure:(state,{payload}) => {
            state.piscLoading=false;
            state.pcstatus="fail";
            state.pcMessage=payload.message;
            
        },
    },
});

const { reducer, actions } = productSlice;

export const { getProductPending, getProductSuccess, getProductImagePending,getProductImageFail,getProductImageSuccess,getProductFail,getSProductPending, getSProductSuccess, getSProductFail, 
    createProductPending, createProductSuccess, createProductFail,
    modifyProductPending,modifyProductSuccess,modifyProductFail,
    deleteProductPending,deleteProductSuccess,deleteProductFail,reset,imageUploadSuccess,imageUploadFailure,getSProductImagePending,getSProductImageSuccess,getSProductImageFail,modifyProductImagePending,modifyProductImageSuccess,modifyProductImageFail,deleteProductImageFail,deleteProductImageSuccess,deleteProductImagePending} = actions;

export default reducer;
